import React from 'react'
import { View } from 'react-native'
import Styles from './style'
import Typography from 'APP/Converse/Typography'

type Props = {
  isTrue?: boolean
  isTrueText: string
  isFalseText: string
}

const InfoTextBoolean = ({ isTrueText, isFalseText, isTrue }: Props) => (
  <View style={isTrue ? Styles.infoTextItemTrue : Styles.infoTextItemFalse}>
    <Typography style={Styles.infoText}>{isTrue ? isTrueText : isFalseText}</Typography>
  </View>
)

export default InfoTextBoolean
